import { produce } from 'immer';

import { workspaceActionTypes } from './workspace.types';

const initialState = {
    // All workspaces the user belongs to.
    // Each workspace: { id, name, slug, owner_id, pricing_plan, seats, seats_used, role, created_at, updated_at }
    // list: [],
    list: [
        { id: 1, name: 'My Workspace', slug: 'MW', owner_id: '123', pricing_plan: '', seats: '', seats_used: '', role: '', created_at: '', updated_at: '' }
    ],
    // The currently active workspace object.
    // currentWorkspace: null,
    currentWorkspace: { id: 1, name: 'My Workspace', slug: 'MW', owner_id: '123', pricing_plan: '', seats: '', seats_used: '', role: '', created_at: '', updated_at: '' },

    // Teams inside the current workspace.
    // Each team: { id, workspace_id, name, members_count, created_at }
    teams: [],

    // Members inside the current workspace.
    // Each member: { id, user_id, workspace_id, role, email, name, image, joined_at }
    members: [],

    // Pricing plan key: 'free' | 'basic' | 'professional'
    plan: 'free',

    // Computed restrictions object derived from plan (see workspace.plans.js).
    restrictions: null,

    // True once the first workspace fetch completes (success or failure).
    isInitialized: false,

    isLoading: false,
    error: null,
};

const workspaceReducer = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {

            // INIT
            case workspaceActionTypes.WORKSPACE_INIT_REQUEST: {
                draft.isLoading = true;
                draft.error = null;
                break;
            }
            case workspaceActionTypes.WORKSPACE_INIT_SUCCESS: {
                const { list, currentWorkspace, plan, restrictions } = action.payload;
                draft.list = list;
                draft.currentWorkspace = currentWorkspace;
                draft.plan = plan;
                draft.restrictions = restrictions;
                draft.isLoading = false;
                draft.isInitialized = true;
                draft.error = null;
                break;
            }
            case workspaceActionTypes.WORKSPACE_INIT_FAILURE: {
                draft.isLoading = false;
                // Mark as initialized even on failure so the app never hangs.
                draft.isInitialized = true;
                draft.error = action.payload;
                break;
            }

            // SWITCH WORKSPACE
            case workspaceActionTypes.WORKSPACE_SWITCH_REQUEST: {
                draft.isLoading = true;
                break;
            }
            case workspaceActionTypes.WORKSPACE_SWITCH_SUCCESS: {
                const { currentWorkspace, plan, restrictions } = action.payload;
                draft.currentWorkspace = currentWorkspace;
                draft.plan = plan;
                draft.restrictions = restrictions;
                // Clear stale team/member data from the previous workspace.
                draft.teams = [];
                draft.members = [];
                draft.isLoading = false;
                break;
            }

            // FETCH TEAMS
            case workspaceActionTypes.WORKSPACE_FETCH_TEAMS_REQUEST: {
                draft.isLoading = true;
                break;
            }
            case workspaceActionTypes.WORKSPACE_FETCH_TEAMS_SUCCESS: {
                draft.teams = action.payload;
                draft.isLoading = false;
                break;
            }
            case workspaceActionTypes.WORKSPACE_FETCH_TEAMS_FAILURE: {
                draft.isLoading = false;
                draft.error = action.payload;
                break;
            }

            // FETCH MEMBERS
            case workspaceActionTypes.WORKSPACE_FETCH_MEMBERS_REQUEST: {
                draft.isLoading = true;
                break;
            }
            case workspaceActionTypes.WORKSPACE_FETCH_MEMBERS_SUCCESS: {
                draft.members = action.payload;
                draft.isLoading = false;
                break;
            }
            case workspaceActionTypes.WORKSPACE_FETCH_MEMBERS_FAILURE: {
                draft.isLoading = false;
                draft.error = action.payload;
                break;
            }

            // RESET (sign out)
            case workspaceActionTypes.WORKSPACE_RESET: {
                return initialState;
            }

            default:
                break;
        }
    });
};

export default workspaceReducer;
